/* @flow weak */
import * as React from 'react';

import OrganizationActions from 'actions/OrganizationActions';
import ToastActions from 'actions/ToastActions';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import Text from 'components/Text';
import { ReportOrgUserOptions } from 'constants/ReportConstants';
import ReportToRemindSelectModal from 'support/components/ReportToRemindSelectModal';

type Props = {
  userName: string,
  userId: string | number,
  orgName: string,
  orgId: string | number,
  removeModal: Function,
  onRequestHide?: ?Function,
};

class ReportOrgUserModal extends React.Component<Props> {
  handleCancel = () => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };

  handleReport = (key, notes) => {
    const { onRequestHide, orgId, userId } = this.props;

    const onSuccess = () => {
      ToastActions.showSuccessToast('Report submitted');
      if (onRequestHide) {
        onRequestHide();
      }
    };

    const onError = function() {
      ToastActions.showErrorToast('Something went wrong. Please try again.');
    };

    OrganizationActions.reportUserAsAdmin(orgId, userId, key, notes).then(onSuccess, onError);
  };

  render() {
    const { orgName, removeModal, userId, userName, ...props } = this.props;

    return (
      <ReportToRemindSelectModal
        {...props}
        notesRequired
        options={ReportOrgUserOptions}
        reportee={userName}
        className="ReportOrgUserModal"
        onReport={this.handleReport}>
        <Text align="left" element="p">
          If {userName} is erroneously linked to {orgName}, please{' '}
          <ModalTrigger modal={removeModal(userName, userId)}>
            <Link
              className="ReportOrgUserModal-remove"
              onClick={this.handleCancel}
              eventElementName="ReportOrgUserModal-remove">
              remove this person from your school
            </Link>
          </ModalTrigger>
          .
        </Text>
      </ReportToRemindSelectModal>
    );
  }
}

export default ReportOrgUserModal;
